import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useInvoice} from "../hooks/useInvoice.ts";
import {Invoice} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: customerId} = useParams();

    if (!customerId) {
        throw new Error('customerId is required');
    }

    const {
        createRecord,
    } = useInvoice();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: customerId,
            } as Invoice}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
